import React from 'react';
import "./LayoutBackground.css"

import Sidebar from 'Components/SideBar/SideBarComponents/SiderBar';

const LayoutBackground = () => {

    return (
        <React.Fragment>
            <div className='background' />
                <aside className='side-bar'>
                    <Sidebar />
                </aside>
                
        </React.Fragment >
    );
};

export default LayoutBackground;